import { GET } from './api'

const table = "file-template"

export const Read = async () => {
    return await GET(`/${table}`, false);
}